export const brandsEndpoint = state => `${state.config.apiUrl}/v1/brands`;

export const updateBrandEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/brands/${payload.brandId}`
);
export const updateBrandBrandingEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/brands/${payload.brandId}/branding`
);
export const updateBrandOptionsEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/brands/${payload.brandId}/options`
);
export const getBrandEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/brands/${payload.brandId}`
);



// WEBPACK FOOTER //
// ./src/services/brands/selectors.js